import React from 'react';

import LoaderIcon from '../../assets/icons/loader-icon';

const CircleLoader = () => {
  return (
    <div className="animate-spin">
      <LoaderIcon />
    </div>
  );
};

export default CircleLoader;
